/**
 * A project that will not open (07 Workshop, row 46): a link to a project that
 * was deleted, or that nobody shared with you. It says what happened and the
 * way back; the person's own projects are in the sidebar. A request that never
 * reached Mohtawa says that instead, with Try again.
 */
import { ArrowLeft, FolderX, WifiOff } from "lucide-react";
import { KitButton } from "@/app/routes/dashboard/components/kit/Button";
import { ErrorState } from "@/app/routes/dashboard/components/ViewStates";

export default function WorkshopCouldNotOpen({
  unreachable = false,
  onRetry,
  onBack,
}: {
  /** The read never reached Mohtawa: say so instead of guessing why. */
  unreachable?: boolean;
  onRetry?: () => void;
  onBack: () => void;
}) {
  if (unreachable) {
    return (
      <ErrorState
        className="ws-cno"
        icon={<WifiOff aria-hidden />}
        title="Can't reach Mohtawa"
        body="Your connection dropped or the server did not answer. The project is safe; try again once you are back online."
        onRetry={onRetry}
      />
    );
  }
  return (
    <ErrorState
      className="ws-cno"
      icon={<FolderX aria-hidden />}
      title="Could not open this project"
      body="It may have been deleted, or it is not shared with you. Your own projects are in the sidebar."
      actions={
        <KitButton iconLeft={ArrowLeft} onClick={onBack} className="h-10 text-[13.5px] font-semibold">
          Projects
        </KitButton>
      }
    />
  );
}
